import { DisabilityImpactDTO } from "Shared/DTOs/DisablityImpactDTO";
import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";

export class DisabilityImpactModel extends ModelBase<DisabilityImpactModel, DisabilityImpactDTO> {
    @observable public id: string = "";
    @observable public backgroundInformationDisabilityImpactId: string | null = null;
    @observable public name: string = "";
    @observable public type: number = 0;
    @observable public ordinal: number = 0;
    @observable public isDeleted: boolean = false;
    @observable public otherDetail: string = "";

    @action
    public fromDto = (dto: DisabilityImpactDTO): void => {
        if (!dto) return;
        this.id = dto.id;
        this.backgroundInformationDisabilityImpactId = dto.backgroundInformationDisabilityImpactId ?? null;
        this.name = dto.name;
        this.type = dto.type;
        this.ordinal = dto.ordinal;
        this.isDeleted = dto.isDeleted;
        this.otherDetail = dto.otherDetail ?? "";
    };

    @action
    public toDto = (): DisabilityImpactDTO => {
        return {
            id: this.id,
            backgroundInformationDisabilityImpactId: this.backgroundInformationDisabilityImpactId || undefined,
            name: this.name,
            type: this.type,
            ordinal: this.ordinal,
            isDeleted: this.isDeleted,
            otherDetail: this.otherDetail || undefined,
        } as DisabilityImpactDTO;
    };

    @action
    public resetModel = (): void => {
        this.id = "";
        this.backgroundInformationDisabilityImpactId = null;
        this.name = "";
        this.type = 0;
        this.ordinal = 0;
        this.isDeleted = false;
        this.otherDetail = "";
    };
}
